<template>
  <div class="brand-pass" v-loading="loading">
    <!-- 顶部油站名称栏 + 更新时间（集团站可切换油站） -->
    <station-bar
      :value="currentGasId"
      :stations="stations"
      :current-name="currentName"
      :selectable="isCompany"
      :update-time="data.updateTime"
      @change="onStationChange"
    />

    <!-- 第一行：语音播报（全宽） -->
    <voice-broadcast
      class="row-full"
      :data="data.voice || {}"
    />

    <!-- 双列卡片区 -->
    <div class="grid">
      <!-- 小红书种草码（折线） -->
      <seeding-code
        v-if="data.seedingXhs"
        class="grid-col"
        platform="小红书"
        :icon="iconXhs"
        chart-type="line"
        :data="data.seedingXhs"
      />
      <!-- 抖音种草码（柱状） -->
      <seeding-code
        v-if="data.seedingDouyin"
        class="grid-col"
        platform="抖音"
        :icon="iconDouyin"
        chart-type="bar"
        :data="data.seedingDouyin"
      />

      <!-- 短信 -->
      <reach-card
        class="grid-col"
        title="短信"
        :cards="data.sms || []"
      />
      <!-- PUSH -->
      <reach-card
        class="grid-col"
        title="PUSH"
        :cards="data.push || []"
      />

      <!-- 3km 列表页置顶 -->
      <time-range-card
        class="grid-col"
        title="3km列表页置顶"
        :ranges="data.top3km || []"
      />
      <!-- 品牌旗舰店 -->
      <time-range-card
        class="grid-col"
        title="品牌旗舰店"
        :ranges="data.flagship || []"
      />
      <!-- 油品险 -->
      <time-range-card
        class="grid-col"
        title="油品险"
        :insurance="true"
        :ranges="data.insurance || []"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StationBar from './components/StationBar'
import VoiceBroadcast from './components/VoiceBroadcast'
import SeedingCode from './components/SeedingCode'
import ReachCard from './components/ReachCard'
import TimeRangeCard from './components/TimeRangeCard'
import { getBrandPassStations, getDefaultStation, getBrandPassData } from './api'
import iconXhs from './assets/icon-xiaohongshu.png'
import iconDouyin from './assets/icon-douyin.png'

export default {
  name: 'brandPass',
  components: { StationBar, VoiceBroadcast, SeedingCode, ReachCard, TimeRangeCard },
  data () {
    return {
      iconXhs,
      iconDouyin,
      loading: false,
      stations: [], // 集团站油站列表
      currentGasId: '',
      currentName: '',
      data: {} // 当前油站看板数据
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 集团站标志
    isCompany () {
      return !!(this.userInfo && this.userInfo.company)
    }
  },
  methods: {
    async init () {
      this.loading = true
      try {
        if (this.isCompany) {
          // 集团站：取油站列表，默认取第一个
          const list = await getBrandPassStations()
          this.stations = list || []
          if (this.stations.length) {
            const picked = this.stations[0]
            this.currentGasId = picked.gasId
            this.currentName = picked.gasName
          }
        } else {
          // 单站：取本站
          const single = await getDefaultStation()
          this.currentGasId = single.gasId
          this.currentName = single.gasName
        }
        await this.loadData()
      } finally {
        this.loading = false
      }
    },
    async loadData () {
      if (!this.currentGasId) return
      this.loading = true
      try {
        this.data = (await getBrandPassData({ gasId: this.currentGasId })) || {}
      } finally {
        this.loading = false
      }
    },
    onStationChange (item) {
      this.currentGasId = item.gasId
      this.currentName = item.gasName
      this.loadData()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import './styles.less';
.brand-pass {
  padding: 16px;
  background: @bp-page-bg;
  min-height: 100%;
  // 顶部栏与下方模块间距
  .row-full {
    margin-top: @bp-col-gap;
  }
  .grid {
    margin-top: @bp-col-gap;
    display: flex;
    flex-wrap: wrap;
    gap: @bp-col-gap;
    .grid-col {
      // 双列：减去间距的一半
      width: calc(~"(100% - @{bp-col-gap}) / 2");
      box-sizing: border-box;
    }
  }
  // 卡片通用（各组件根节点 .bp-card）
  /deep/ .bp-card {
    background: @bp-card-bg;
    border-radius: @bp-card-radius;
    padding: @bp-card-padding;
    box-sizing: border-box;
  }
}
</style>
